//注册全局过滤器
import Vue from 'vue';
import './filter';
//引入服务器字典 挂载到mixins中用于检测并请求需要的字典数据
import {seviceMinxins} from './minxins/serviceDic';
Vue.mixin(seviceMinxins)
